import { GET_LOCATION_REQUESTED, UPDATE_LOCATION_REQUESTED } from './edit.actions';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../../../api/api.service';
import { NotificationService } from '../../../common/services/notification/notification.service';
import store from './../../../store/store.module';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { DELETE_LOCATION_REQUESTED } from '../list/list.action';
import { LOCATION_COMP } from '../location.consts';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnDestroy {
  navigationSubscription: Subscription;
  public store = store;
  protected router: Router;
  protected location = {};

  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, router: Router) {
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: GET_LOCATION_REQUESTED, data: this.activeRouter.snapshot.paramMap.get('id') });
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  onSubmit(form) {
    if (form.valid) {
      let location = (store as any).getState().Location.edit.item;
      // console.log(location);
      let data = {
        id: location.getId(),
        code: location.getCode(),
        name: location.getName(),
        type: location.getType(),
        destination_id: location.destination.getId()
      };
      store.dispatch({ type: UPDATE_LOCATION_REQUESTED, data: data });
    }
  }

  deleteLocation(location_id) {
    store.dispatch({
      type: DELETE_LOCATION_REQUESTED,
      data: location_id,
      com: LOCATION_COMP
    });
  }
}
